exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/** Colors */\n/** FlatUI Color Palette\n*\n*\tColor names based on FlatUI: https://flatuicolors.com/\n*/\n/** Acrylic Color Palette\n*\n*\tColor names based on Name that Color: http://chir.ag/projects/name-that-color\n*/\n.removable-content .content-title {\n  display: flex;\n  flex-direction: row;\n  border-bottom: 1px solid #eeeeee;\n  padding-bottom: 8px;\n  margin-bottom: 10px; }\n  .removable-content .content-title .remove-btn:hover i {\n    color: #da3232; }\n", ""]);

// exports
